// English & Turkish translations for PMCoach AI
export const STRINGS = {
  en: {
    // Common
    "common.loading": "Loading…",
    "common.signin": "Sign in",
    "common.login": "Log in",
    "common.signup": "Sign up",
    "common.signout": "Sign out",
    "common.cancel": "Cancel",
    "common.save": "Save",
    "common.delete": "Delete",
    "common.create": "Create",
    "common.start": "Start",
    "common.next": "Next",
    "common.previous": "Previous",
    "common.finish": "Finish",
    "common.submit": "Submit",
    "common.continue": "Continue",
    "common.cont_with_google": "Continue with Google",
    "common.or": "or",
    "common.email": "Email",
    "common.password": "Password",
    "common.name": "Full name",
    "common.language": "Language",
    "common.english": "English",
    "common.turkish": "Türkçe",
    "common.demo_account": "Demo account",
    "common.review": "Review",
    "common.completed": "Completed",
    "common.open": "Open",
    "common.high": "high",
    "common.medium": "medium",
    "common.low": "low",
    "common.priority": "Priority",
    "common.deadline": "Deadline",
    "common.title": "Title",
    "common.description": "Description",
    "common.type": "Type",
    "common.domain": "Domain",
    "common.all": "All",
    "common.any": "Any",
    "common.questions": "Questions",
    "common.minutes": "minutes",
    "common.failed": "Something went wrong",

    // Nav
    "nav.dashboard": "Dashboard",
    "nav.practice": "Practice",
    "nav.mock": "Mock Exam",
    "nav.study_plan": "Study Plan",
    "nav.tasks": "Tasks",
    "nav.progress": "Progress",
    "nav.profile": "Profile",

    // Landing
    "landing.overline": "PMBOK 8 · AI COACHING · REAL EXAM SIM",
    "landing.h1.line1": "Pass the PMP —",
    "landing.h1.line2": "guided by an AI coach",
    "landing.h1.line3": "that watches every answer.",
    "landing.subtitle": "PMCoach AI quizzes you, scores you across PMBOK 8 domains, and re-plans your week automatically. No fluff. Just the shortest path to ready.",
    "landing.cta.primary": "Get started",
    "landing.cta.secondary": "I already have an account",
    "landing.bullets.1": "1,000+ practice questions",
    "landing.bullets.2": "180-question mock simulator",
    "landing.bullets.3": "Adaptive weekly plan",
    "landing.readiness.label": "Readiness Score",
    "landing.readiness.note": "Approaching exam-ready · weak:",
    "landing.features.overline": "FEATURES",
    "landing.features.title": "A pipeline, not a quiz app.",
    "landing.features.subtitle": "Most PMP apps test you. We coach you — analyzing every attempt and rebuilding your week around the gaps.",
    "landing.feature.ai.title": "AI Coach",
    "landing.feature.ai.body": "Personalised feedback after every quiz: weak domains, strengths, exact next steps.",
    "landing.feature.score.title": "Readiness Score",
    "landing.feature.score.body": "A single 0–100 number — calibrated by domain balance — tells you exactly when you're ready.",
    "landing.feature.pipeline.title": "Progress Pipeline",
    "landing.feature.pipeline.body": "Auto-generated weekly study plans that adapt as you improve.",
    "landing.feature.bank.title": "1,000+ PMP Questions",
    "landing.feature.bank.body": "Practice across People, Process, and Business Environment — every difficulty.",
    "landing.pricing.overline": "PRICING",
    "landing.pricing.title": "Simple pricing. Upgrade when you're closing in on ready.",
    "landing.tier.free.desc": "Get started — limited daily questions.",
    "landing.tier.pro.desc": "Unlimited practice + AI analysis.",
    "landing.tier.master.desc": "The full coaching pipeline.",
    "landing.tier.popular": "MOST POPULAR",
    "landing.footer": "© {year} PMCoach AI. Built for project managers.",

    // Auth pages
    "auth.welcome_back": "Welcome back",
    "auth.welcome_back_sub": "Pick up where your AI coach left off.",
    "auth.start_pipeline": "Start your PMP pipeline",
    "auth.start_pipeline_sub": "Free forever — upgrade only when you're closing in.",
    "auth.no_account": "New here?",
    "auth.create_account": "Create an account",
    "auth.forgot_password": "Forgot password?",
    "auth.have_account": "Already have an account?",
    "auth.testimonial": "\"The AI coach pinpointed my Process gap in week 1. I passed in 7 weeks.\"",
    "auth.testimonial_attribution": "— Priya, PMP®",
    "auth.signing_in": "Signing in…",
    "auth.creating": "Creating account…",
    "auth.and": "and",
    "auth.create_btn": "Create account",
    "auth.login_failed": "Login failed",
    "auth.register_failed": "Registration failed",

    // Dashboard
    "dash.overline": "CONTROL ROOM",
    "dash.greeting": "Hi {name}, here's your readiness",
    "dash.greeting_default": "there",
    "dash.start_mock": "Start Mock Exam",
    "dash.readiness": "PMP Readiness Score",
    "dash.last_score": "Last score",
    "dash.attempts": "Attempts",
    "dash.solved": "Solved",
    "dash.domain_breakdown": "Domain breakdown",
    "dash.domain_subtitle": "PMBOK 8 — last attempt",
    "dash.no_attempts": "No attempts yet.",
    "dash.no_attempts_link": "Run a quick practice quiz",
    "dash.no_attempts_suffix": "to seed your dashboard.",
    "dash.ai_insight": "AI INSIGHT",
    "dash.weakest": "Weakest",
    "dash.weakest_suffix": "Focus your next session here.",
    "dash.coach": "AI Coach",
    "dash.coach_title": "Ask for next step",
    "dash.coach_sub": "Get a focused, personalised next move based on your last attempt.",
    "dash.coach_btn": "Ask coach",
    "dash.coach_thinking": "Thinking…",
    "dash.focus_generating": "Crafting today's focus…",
    "dash.focus_refresh": "Regenerate",
    "dash.focus_minutes": "min",
    "dash.focus_chat": "Ask the coach anything",
    "dash.focus_cooldown": "Please wait a moment before regenerating.",
    "dash.coach_unavailable": "Coach unavailable",
    "dash.progress_overline": "Progress over time",
    "dash.progress_title": "Score history",
    "dash.no_history": "No history yet — finish a quiz to see progress.",
    "dash.tasks_open": "{n} open",
    "dash.view_all": "View all",
    "dash.no_tasks": "No tasks yet — finish a quiz and we'll add some.",
    "dash.activity": "ACTIVITY",
    "dash.recent_updates": "Recent updates",
    "dash.no_notifications": "No notifications yet.",
    "dash.inactivity": "You haven't studied in {days} days.",
    "dash.inactivity_suffix": "A 15-min session keeps your streak alive.",
    "dash.load_failed": "Failed to load dashboard",

    // Practice
    "practice.overline": "PRACTICE",
    "practice.title": "Build your reps.",
    "practice.subtitle": "Pick a domain, difficulty, and length. Every answer is explained and tracked.",
    "practice.domain": "Domain",
    "practice.difficulty": "Difficulty",
    "practice.questions": "Questions",
    "practice.start": "Start practice",
    "practice.preparing": "Preparing…",
    "practice.could_not_start": "Could not start quiz",
    "diff.easy": "Easy", "diff.medium": "Medium", "diff.hard": "Hard",
    "domain.People": "People", "domain.Process": "Process", "domain.Business Environment": "Business Environment",

    // Quiz Runner
    "quiz.mock_label": "MOCK EXAM",
    "quiz.practice_label": "PRACTICE",
    "quiz.q_of": "Question {n} of {total}",
    "quiz.answered": "Answered:",
    "quiz.submitting": "Submitting…",
    "quiz.finish_analyze": "Finish & analyze",
    "quiz.failed_submit": "Failed to submit attempt",
    "quiz.translating": "Translating…",

    // Mock Exam
    "mock.title": "180 questions · 230 minutes",
    "mock.subtitle": "Real exam blueprint — 76 People, 90 Process, 14 Business Environment. The timer counts down from 03:50:00. You can submit early. AI analysis runs automatically on submit.",
    "mock.warning": "Once started, the timer cannot be paused.",
    "mock.start": "Start mock exam",
    "mock.scoring": "Scoring & running AI analysis…",
    "mock.could_not_start": "Could not start mock exam",
    "mock.submit_failed": "Submission failed",
    "mock.submit": "Submit",
    "mock.finish_exam": "Finish exam",

    // Results
    "results.overline_results": "RESULTS",
    "results.title": "Your attempt is scored.",
    "results.score": "Score",
    "results.domain_breakdown": "Domain Breakdown",
    "results.ai_overline": "AI COACH",
    "results.diagnosis": "Diagnosis",
    "results.weak": "Weak",
    "results.strong": "Strong",
    "results.improvement": "Improvement plan",
    "results.next_steps": "Suggested next steps",
    "results.update_plan": "Update my study plan",
    "results.practice_weak": "Practice weak domain",
    "results.review_count": "Review · {n} questions",
    "results.explanation": "EXPLANATION",
    "results.could_not_load": "Could not load attempt",

    // Tasks
    "tasks.overline": "TASKS",
    "tasks.title": "Your study queue",
    "tasks.add": "New task",
    "tasks.create_failed": "Could not create task",
    "tasks.added": "Task added",
    "tasks.all_caught_up": "All caught up.",
    "tasks.no_completed": "No completed tasks yet.",
    "tasks.due": "due",
    "tasks.overdue": "overdue",

    // Study Plan
    "plan.overline": "WEEKLY PLAN",
    "plan.title": "Your AI-built week",
    "plan.subtitle": "Plans adapt automatically as your domain scores change.",
    "plan.regenerate": "Regenerate",
    "plan.generating": "Generating…",
    "plan.refreshed": "Study plan refreshed",
    "plan.no_plan": "Generate your first weekly plan",
    "plan.no_plan_sub": "We'll build it from your latest attempt — or use defaults if you haven't taken one yet.",
    "plan.generate": "Generate plan",
    "plan.rationale": "AI RATIONALE",
    "plan.target": "Target:",
    "plan.target_suffix": "questions",
    "plan.could_not_refresh": "Could not refresh plan",

    // Progress
    "progress.overline": "PROGRESS",
    "progress.title": "Your trajectory",
    "progress.no_attempts": "No attempts yet",
    "progress.no_attempts_sub": "Run a practice quiz or mock exam to start your trajectory.",
    "progress.score_readiness": "Score & Readiness over time",
    "progress.domain_avg": "Domain averages (last 5)",
    "progress.history": "Attempt history",
    "progress.col.date": "Date", "progress.col.mode": "Mode", "progress.col.score": "Score",
    "progress.col.readiness": "Readiness", "progress.col.questions": "Questions",
    "progress.review_link": "Review →",

    // Profile
    "profile.overline": "PROFILE",
    "profile.title": "Your account",
    "profile.account": "Account",
    "profile.signin_method": "Sign-in method",
    "profile.plan": "Plan",
    "profile.recommended": "RECOMMENDED",
    "profile.current": "Current plan",
    "profile.upgrading": "Upgrading…",
    "profile.upgrade_mock": "Upgrade (mock)",
    "profile.toast_mock": "Mock upgrade to {tier} (payments not enabled in MVP)",
    "auto.strengthen": "Strengthen {domain}",
    "auto.strengthen_desc": "Solve 15 targeted questions on this domain and review every explanation.",

    // Streak & daily goal
    "streak.title": "Daily streak",
    "streak.current": "Current",
    "streak.longest": "Longest",
    "streak.days": "days",
    "streak.goal": "Daily goal",
    "streak.today": "Today",
    "streak.goal_set": "Daily goal updated",
    "streak.goal_failed": "Could not update goal",
    "streak.goal_hit": "Goal hit — fire!",
    "streak.start_today": "Start today's reps",
    "streak.keep_going": "{remaining} more to hit today's goal",

    // Review (spaced repetition)
    "nav.review": "Review",
    "review.overline": "SPACED REPETITION",
    "review.title": "Your review queue",
    "review.subtitle": "Questions you missed are scheduled to come back at the right time.",
    "review.due": "Due now",
    "review.total": "Total in queue",
    "review.start": "Start review",
    "review.empty": "Nothing due — keep practicing and missed questions will land here.",
    "review.no_due": "All caught up!",
    "review.starting": "Loading review…",
    "review.could_not_start": "Could not start review",
    "review.dashboard_label": "Review queue",
    "review.dashboard_due": "{n} due",

    // Adaptive
    "practice.adaptive": "Adaptive difficulty",
    "practice.adaptive_hint": "AI auto-tunes difficulty to your recent accuracy.",
    "practice.mode_review": "Review mode",

    // Analytics
    "analytics.section": "Analytics",
    "analytics.radar_overline": "DOMAIN COVERAGE",
    "analytics.radar_title": "Performance map",
    "analytics.current": "Current",
    "analytics.best": "Best",
    "analytics.heatmap_overline": "ACTIVITY",
    "analytics.heatmap_title": "Last 12 weeks",
    "analytics.total_solved": "Total solved",
    "analytics.active_days": "active days",
    "analytics.less": "Less",
    "analytics.more": "More",
    "analytics.donut_overline": "DIFFICULTY MIX",
    "analytics.donut_title": "Questions attempted",
    "analytics.acc_diff_overline": "PRECISION",
    "analytics.acc_diff_title": "Accuracy by difficulty",
    "analytics.spark_overline": "TREND",
    "analytics.spark_title": "Per-domain trend",
    "analytics.totals_overline": "TOTALS",
    "analytics.total_minutes": "Study minutes",
    "analytics.overall_accuracy": "Overall accuracy",

    // Nav (public)
    "nav.home": "Home",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.privacy": "Privacy",
    "nav.kvkk": "KVKK / GDPR",
    "nav.terms": "Terms of Use",
    "nav.distance_sales": "Distance Selling Agreement",
    "nav.refund": "Cancellation & Refund",
    "nav.cookies": "Cookie Policy",
    "nav.faq": "FAQ",
    "nav.admin": "Admin",
    "nav.affiliate": "Affiliate",

    // Footer
    "footer.tagline": "AI-powered PMP coaching that watches every answer and re-plans your week.",
    "footer.product": "Product",
    "footer.company": "Company",
    "footer.legal": "Legal",
    "footer.rights": "All rights reserved.",

    // Contact page
    "contact.title": "Get in touch",
    "contact.subtitle": "Questions, partnership, or feedback — drop us a line and we'll respond within 24 hours.",
    "contact.subject": "Subject",
    "contact.message": "Message",
    "contact.send": "Send message",
    "contact.sending": "Sending…",
    "contact.sent": "Message sent — we'll get back to you shortly.",
    "contact.phone": "Phone",
    "contact.address": "Address",

    // FAQ page
    "faq.subtitle": "Everything you need to know before starting your PMP journey.",

    // Admin panel
    "admin.title": "Site Administration",
    "admin.subtitle": "Edit public pages, contact info, FAQ items, social links, and incoming messages.",
    "admin.title_tr": "Title (TR)",
    "admin.title_en": "Title (EN)",
    "admin.body_tr": "Body (TR)",
    "admin.body_en": "Body (EN)",
    "admin.question_tr": "Question (TR)",
    "admin.question_en": "Question (EN)",
    "admin.answer_tr": "Answer (TR)",
    "admin.answer_en": "Answer (EN)",
    "admin.address_tr": "Address (TR)",
    "admin.address_en": "Address (EN)",
    "admin.save": "Save changes",
    "admin.saving": "Saving…",
    "admin.saved": "Saved",
    "admin.save_failed": "Save failed",
    "admin.deleted": "Deleted",
    "admin.add_question": "Add question",
    "admin.social_hint": "Leave a field empty to hide it from the footer.",
    "admin.no_messages": "No messages yet.",
    "admin.mark_read": "Mark read",
    "admin.tab.about": "About",
    "admin.tab.contact_info": "Contact",
    "admin.tab.privacy": "Privacy",
    "admin.tab.kvkk": "KVKK",
    "admin.tab.terms": "Terms",
    "admin.tab.distance_sales": "Distance Sales",
    "admin.tab.refund": "Refund",
    "admin.tab.cookies": "Cookies",
    "admin.tab.faq": "FAQ",
    "admin.tab.social_links": "Social",
    "admin.tab.homepage_extra": "Homepage",
    "admin.tab.messages": "Messages",
    "admin.reset_default": "Reset to default",
    "admin.reset_confirm": "Reset this page back to the bundled default template? Your edits will be lost.",
    "admin.reset_success": "Reset to default template.",
    "admin.delete": "Delete",
    // Admin Overview
    "overview.total_users": "Total users",
    "overview.new": "New",
    "overview.paying": "Paying users",
    "overview.conversion": "conversion",
    "overview.mrr": "MRR",
    "overview.monthly_recurring": "Monthly recurring",
    "overview.revenue_30d": "Revenue (30d)",
    "overview.total": "All-time",
    "overview.affiliates": "Affiliates",
    "overview.active": "active",
    "overview.active_coupons": "Active coupons",
    "overview.redemptions": "redemptions",
    "overview.unread_msg": "Unread messages",
    "overview.contact_forms": "Contact forms",
    "overview.pro_active": "Pro active",
    "overview.recent_payments": "Recent payments",
    "overview.no_payments_yet": "No payments yet.",
    "overview.recent_signups": "Recent signups",
    "overview.top_affiliates": "Top affiliates",
    "overview.commissions": "commissions",
    // Coupons
    "admin.tab.overview": "Overview",
    "admin.tab.plans": "Pricing",
    "admin.tab.coupons": "Coupons",
    "admin.coupon_new": "Create new coupon",
    "admin.coupon_create": "Create coupon",
    "admin.coupon_created": "Coupon created.",
    "admin.coupon_list": "All coupons",
    "admin.coupon_none": "No coupons yet — create your first promotional code above.",
    "admin.coupon_code": "Code",
    "admin.coupon_discount": "Discount",
    "admin.coupon_used": "Used",
    "admin.coupon_status": "Status",
    "admin.coupon_active": "Active",
    "admin.coupon_inactive": "Inactive",
    "admin.coupon_type_percent": "Percent (%)",
    "admin.coupon_type_fixed": "Fixed (₺)",
    "admin.coupon_per_user_limit": "Per-user limit (default 1)",
    "admin.coupon_total_limit": "Total usage limit (empty = unlimited)",
    "admin.coupon_plans": "Applies to plans",
    "admin.coupon_empty_means_all": "leave empty for all plans",
    "admin.coupon_note": "Internal note (e.g. campaign name)",
    "admin.coupon_delete_confirm": "Delete coupon {code}? This cannot be undone.",
    "admin.pretranslate_title": "Turkish Pre-Translation",
    "admin.pretranslate_running": "Translating to Turkish:",
    "admin.pretranslate_complete": "All questions translated to Turkish ✓",
    "admin.pretranslate_idle": "All questions are already translated.",
    "admin.pretranslate_run": "Re-translate now",
    "admin.pretranslate_started": "Pre-translation started in background.",

    // Cookie banner
    "cookie.title": "We use cookies",
    "cookie.body": "We use essential cookies to make the site work and optional analytics cookies to improve it. You can change your choice anytime.",
    "cookie.learn_more": "Learn more",
    "cookie.accept": "Accept all",
    "cookie.essential_only": "Essential only",

    // Consent (register)
    "consent.kvkk": "I have read and accept the {privacy} and {kvkk}.",
    "consent.kvkk_privacy": "Privacy Policy",
    "consent.kvkk_text": "KVKK Disclosure",
    "consent.kvkk_tail": "documents.",
    "consent.terms": "Membership Agreement",
    "consent.distance_sales": "Distance Selling Agreement",
    "consent.marketing": "I would like to receive product updates and study tips via email (optional).",
    "consent.required": "You must accept the Privacy Policy and KVKK Disclosure to continue.",

    // Exam countdown
    "countdown.title": "PMP exam date",
    "countdown.days_left": "days left",
    "countdown.today": "Today is the day!",
    "countdown.past_exam": "Exam date passed — update or clear",
    "countdown.urgent_message": "Less than a week — switch to mock exams and review weak domains.",
    "countdown.save": "Save date",
    "countdown.edit": "Edit",
    "countdown.cancel": "Cancel",
    "countdown.clear": "Clear",

    // SEO — defaults + per-page
    "seo.default.title": "AI-Powered PMP Exam Preparation",
    "seo.default.description": "PMCoach AI is the AI-powered PMP coaching platform. Adaptive practice, full 180-question mocks, and a personal study plan that adjusts to your weak domains.",
    "seo.default.keywords": "PMP exam prep, PMP questions, PMBOK 8, project management certification, PMP simulator, AI tutor",
    "seo.landing.title": "PMP Exam Prep with AI Coaching",
    "seo.landing.description": "Pass the PMP exam faster with an AI coach that watches every answer and rebuilds your weekly plan. 1700+ bilingual questions, full mocks, spaced repetition.",
    "seo.landing.keywords": "PMP exam, PMP preparation, PMP mock exam, project management, PMBOK 8",
    "seo.login.title": "Sign in",
    "seo.login.description": "Sign in to PMCoach AI and continue your AI-coached PMP exam preparation.",
    "seo.register.title": "Create your free account",
    "seo.register.description": "Sign up in seconds and start your PMP prep with 1,700+ practice questions and AI coaching.",
    "seo.dashboard.title": "Your PMP Dashboard",
    "seo.dashboard.description": "Domain radar, accuracy heatmap, readiness score, and a personalized study plan — all in one place.",
    "seo.about.title": "About PMCoach AI",
    "seo.about.description": "Why we built an AI-powered PMP coach and how it helps you pass faster than traditional question banks.",
    "seo.privacy.title": "Privacy Policy",
    "seo.privacy.description": "How PMCoach AI collects, processes, and protects your personal data.",
    "seo.kvkk.title": "KVKK Disclosure",
    "seo.kvkk.description": "PMCoach AI KVKK (Turkish data protection law) disclosure and your rights.",
    "seo.faq.title": "Frequently Asked Questions",
    "seo.faq.description": "Answers to common questions about PMCoach AI, the PMP exam, and our AI coaching.",
    "seo.blog.title": "PMP & PMBOK 8 Blog",
    "seo.blog.description": "Guides, study plans, and PMBOK 8 breakdowns to help you pass the PMP exam faster.",
    "seo.blog.keywords": "PMP blog, PMBOK 8 guide, PMP tips, project management blog",
    "seo.blog_post.title": "PMCoach AI Blog",
    "seo.blog_post.description": "In-depth PMP and PMBOK 8 content from the PMCoach AI team.",
    "blog.overline": "BLOG",
    "blog.title": "PMP & PMBOK 8 insights",
    "blog.subtitle": "Practical guides and study plans from the PMCoach AI team.",
    "blog.empty": "No posts yet — check back soon.",
    "blog.read_more": "Read more",
    "blog.back_to_list": "Back to blog",
    "blog.min_read": "min read",
    "blog.notfound_title": "Post not found",
    "blog.notfound_body": "This post may have been moved or removed.",
    "blog.cta_title": "Practice what you just read",
    "blog.cta_body": "Sign up for PMCoach AI and put these ideas into a real study plan.",
    "blog.cta_button": "Get started",
    "seo.contact.title": "Contact us",
    "seo.contact.description": "Questions, partnership opportunities, or feedback — get in touch with PMCoach AI.",
    "seo.profile.title": "Profile & Subscription",
    "seo.profile.description": "Manage your PMCoach AI subscription, payment method, and account details.",

    // Dashboard PDF
    "dash.pdf_download": "Download PDF report",
    "dash.pdf_downloading": "Generating…",

    // Affiliate
    "affiliate.overline": "PARTNER PROGRAM",
    "affiliate.title": "Affiliate Program",
    "affiliate.subtitle": "Earn commission on every PMCoach AI subscription you refer. Hybrid model: high first-payment rate plus recurring revenue.",
    "affiliate.apply_form_title": "Become an Affiliate",
    "affiliate.apply_intro": "Tell us a bit about you and how you'd promote PMCoach AI. We review applications within 2 business days.",
    "affiliate.benefit_1": "{rate}% commission on every first payment",
    "affiliate.benefit_2": "{rate}% recurring commission on every renewal",
    "affiliate.benefit_3": "Custom referral link + real-time dashboard",
    "affiliate.name_placeholder": "Your name or company",
    "affiliate.contact_placeholder": "Phone or IBAN for payouts (optional, can add later)",
    "affiliate.audience_placeholder": "Your audience (e.g. PMI Türkiye LinkedIn group)",
    "affiliate.notes_placeholder": "Tell us how you'd promote — channels, content, etc.",
    "affiliate.submit_button": "Submit application",
    "affiliate.submitting": "Submitting…",
    "affiliate.application_submitted": "Application received! We'll get back to you soon.",
    "affiliate.application_failed": "Submission failed. Please try again.",
    "affiliate.pending_overline": "PENDING REVIEW",
    "affiliate.pending_title": "Your application is being reviewed",
    "affiliate.pending_body": "We review affiliate applications within 2 business days. You'll get an email as soon as your account is activated and your referral link is ready.",
    "affiliate.total_referrals": "Total referrals",
    "affiliate.paying_referrals": "Paying customers",
    "affiliate.total_earned": "Total earned",
    "affiliate.pending": "pending payout",
    "affiliate.your_link": "Your referral link",
    "affiliate.copy": "Copy",
    "affiliate.link_copied": "Link copied to clipboard.",
    "affiliate.code_label": "Code",
    "affiliate.first_rate": "First payment rate",
    "affiliate.recurring_rate": "Recurring rate",
    "affiliate.recent_commissions": "Recent commissions",
    "affiliate.no_commissions": "No commissions yet — share your link to start earning.",
    "affiliate.col_date": "Date",
    "affiliate.col_referred": "Referred user",
    "affiliate.col_plan": "Plan",
    "affiliate.col_gross": "Gross",
    "affiliate.col_rate": "Rate",
    "affiliate.col_commission": "Commission",
    "affiliate.col_status": "Status",
    "affiliate.status_paid": "Paid",
    "affiliate.status_pending": "Pending",
    "common.failed": "Failed",

    // Billing / iyzico
    "billing.period_month": "/ month",
    "billing.period_year": "/ year",
    "billing.period_forever": "forever",
    "billing.period_trial": "30-day trial",
    "billing.period_3month": "/ 3 months",
    "billing.period_6month": "/ 6 months",
    "billing.plan_free_name": "Free trial",
    "billing.plan_monthly_name": "1 Month",
    "billing.plan_quarterly_name": "3 Months",
    "billing.plan_semi_name": "6 Months",
    "billing.plan_pro_name": "Pro",
    "billing.plan_master_name": "Premium",
    "billing.feat_full_1": "1,700+ practice questions (all TR + EN)",
    "billing.feat_full_2": "Full 180-question mock exams (unlimited)",
    "billing.feat_full_3": "AI Coach — personalised guidance after each attempt",
    "billing.feat_full_4": "Spaced repetition + adaptive difficulty",
    "billing.feat_full_5": "6-page premium PDF readiness report",
    "billing.feat_full_6": "Auto-generated weekly study plan",
    "billing.kdv_included": "VAT 20% included",
    "billing.upgrade_paytr": "Upgrade with PayTR",
    "billing.always_free": "Always free",
    "billing.starting": "Starting…",
    "billing.expires_on": "Renewal",
    "billing.saved_card": "Saved card",
    "billing.cancel_renew": "Disable auto-renew",
    "billing.cancel_success": "Auto-renew disabled. Your access continues until the renewal date.",
    "billing.cancel_failed": "Could not disable auto-renew.",
    "billing.payment_success": "Payment successful — welcome aboard!",
    "billing.payment_failed": "Payment failed or cancelled.",
    "billing.init_failed": "Could not start payment. Please try again.",
    "billing.paytr_safe": "Secured by PayTR · 3D Secure",
    "billing.secure_payment": "Secure Payment",
    "billing.complete_payment": "Complete your purchase",
    "billing.not_configured_warning": "Payments are not yet configured. The administrator needs to add iyzico API keys to enable upgrades.",
    "billing.feat_free_1": "30-day free trial with all features",
    "billing.feat_free_2": "Full mock exams + AI Coach included",
    "billing.feat_free_3": "No credit card required",
    "billing.feat_pro_1": "Unlimited practice questions",
    "billing.feat_pro_2": "Full 180-question mock exams",
    "billing.feat_pro_3": "AI Coach (GPT-5.2) on every attempt",
    "billing.feat_pro_4": "Adaptive difficulty engine",
    "billing.feat_pro_5": "Bilingual TR/EN questions",
    "billing.feat_master_1": "Everything in Pro",
    "billing.feat_master_2": "2 months free vs monthly",
    "billing.feat_master_3": "Personal study plan generator",
    "billing.feat_master_4": "PDF readiness reports",
    "billing.feat_master_5": "Priority support",
    "billing.feat_master_6": "Early access to new features",
    "billing.have_coupon": "Have a coupon code?",
    "billing.apply_coupon": "Apply",
    "billing.coupon_valid": "Coupon valid — {amount}₺ discount will be applied at checkout.",
    "billing.coupon_invalid": "Coupon invalid or expired.",
    "billing.discount_applied": "discount",
  },
  tr: {
    // Common
    "common.loading": "Yükleniyor…",
    "common.signin": "Giriş yap",
    "common.login": "Giriş",
    "common.signup": "Kayıt ol",
    "common.signout": "Çıkış yap",
    "common.cancel": "İptal",
    "common.save": "Kaydet",
    "common.delete": "Sil",
    "common.create": "Oluştur",
    "common.start": "Başla",
    "common.next": "İleri",
    "common.previous": "Geri",
    "common.finish": "Bitir",
    "common.submit": "Gönder",
    "common.continue": "Devam",
    "common.cont_with_google": "Google ile devam et",
    "common.or": "veya",
    "common.email": "E-posta",
    "common.password": "Şifre",
    "common.name": "Ad Soyad",
    "common.language": "Dil",
    "common.english": "English",
    "common.turkish": "Türkçe",
    "common.demo_account": "Demo hesap",
    "common.review": "İncele",
    "common.completed": "Tamamlanan",
    "common.open": "Açık",
    "common.high": "yüksek",
    "common.medium": "orta",
    "common.low": "düşük",
    "common.priority": "Öncelik",
    "common.deadline": "Son tarih",
    "common.title": "Başlık",
    "common.description": "Açıklama",
    "common.type": "Tür",
    "common.domain": "Alan",
    "common.all": "Tümü",
    "common.any": "Hepsi",
    "common.questions": "Soru",
    "common.minutes": "dakika",
    "common.failed": "Bir şeyler ters gitti",

    // Nav
    "nav.dashboard": "Panel",
    "nav.practice": "Pratik",
    "nav.mock": "Deneme Sınavı",
    "nav.study_plan": "Çalışma Planı",
    "nav.tasks": "Görevler",
    "nav.progress": "İlerleme",
    "nav.profile": "Profil",

    // Landing
    "landing.overline": "PMBOK 8 · AI KOÇU · GERÇEK SINAV SİMÜLASYONU",
    "landing.h1.line1": "PMP'yi geç —",
    "landing.h1.line2": "her cevabını izleyen",
    "landing.h1.line3": "bir AI koçun rehberliğinde.",
    "landing.subtitle": "PMCoach AI sana sorular sorar, PMBOK 8 alanlarında puan verir ve haftanı otomatik yeniden planlar. Lafı yok. Sadece hazır olmaya giden en kısa yol.",
    "landing.cta.primary": "Hemen başla",
    "landing.cta.secondary": "Hesabım var",
    "landing.bullets.1": "1.000+ pratik soru",
    "landing.bullets.2": "180 soruluk deneme sınavı",
    "landing.bullets.3": "Uyarlanabilir haftalık plan",
    "landing.readiness.label": "Hazırlık Skoru",
    "landing.readiness.note": "Sınava yaklaşıyor · zayıf:",
    "landing.features.overline": "ÖZELLİKLER",
    "landing.features.title": "Bir test uygulaması değil, bir koçluk sistemi.",
    "landing.features.subtitle": "Çoğu PMP uygulaması seni test eder. Biz koçluk yaparız — her denemeyi analiz edip haftanı zayıf alanların etrafında yeniden kurarız.",
    "landing.feature.ai.title": "AI Koçu",
    "landing.feature.ai.body": "Her sınavdan sonra kişisel geri bildirim: zayıf alanlar, güçlü yönler, atılacak adımlar.",
    "landing.feature.score.title": "Hazırlık Skoru",
    "landing.feature.score.body": "0–100 arası tek bir sayı — alan dengesine göre kalibre — tam olarak ne zaman hazır olduğunu söyler.",
    "landing.feature.pipeline.title": "İlerleme Hattı",
    "landing.feature.pipeline.body": "Sen geliştikçe uyarlanan, otomatik haftalık çalışma planları.",
    "landing.feature.bank.title": "1.000+ PMP Sorusu",
    "landing.feature.bank.body": "İnsanlar, Süreç ve İş Ortamı alanlarında — her zorlukta pratik yap.",
    "landing.pricing.overline": "FİYATLANDIRMA",
    "landing.pricing.title": "Basit fiyatlandırma. Sınav yaklaşırken yükselt.",
    "landing.tier.free.desc": "Başla — günlük sınırlı sorular.",
    "landing.tier.pro.desc": "Sınırsız pratik + AI analizi.",
    "landing.tier.master.desc": "Eksiksiz koçluk hattı.",
    "landing.tier.popular": "EN POPÜLER",
    "landing.footer": "© {year} PMCoach AI. Proje yöneticileri için yapıldı.",

    // Auth pages
    "auth.welcome_back": "Tekrar hoş geldin",
    "auth.welcome_back_sub": "AI koçunla kaldığın yerden devam et.",
    "auth.start_pipeline": "PMP yolculuğuna başla",
    "auth.start_pipeline_sub": "Sonsuza kadar ücretsiz — yalnızca yaklaşırken yükselt.",
    "auth.no_account": "Yeni misin?",
    "auth.create_account": "Hesap oluştur",
    "auth.forgot_password": "Parolamı unuttum",
    "auth.have_account": "Zaten bir hesabın var mı?",
    "auth.testimonial": "\"AI koçu Süreç eksiğimi 1. hafta tespit etti. 7 haftada geçtim.\"",
    "auth.testimonial_attribution": "— Priya, PMP®",
    "auth.signing_in": "Giriş yapılıyor…",
    "auth.creating": "Hesap oluşturuluyor…",
    "auth.and": "ve",
    "auth.create_btn": "Hesap oluştur",
    "auth.login_failed": "Giriş başarısız",
    "auth.register_failed": "Kayıt başarısız",

    // Dashboard
    "dash.overline": "KONTROL ODASI",
    "dash.greeting": "Merhaba {name}, hazırlık durumun",
    "dash.greeting_default": "arkadaşım",
    "dash.start_mock": "Deneme Sınavını Başlat",
    "dash.readiness": "PMP Hazırlık Skoru",
    "dash.last_score": "Son skor",
    "dash.attempts": "Denemeler",
    "dash.solved": "Çözülen",
    "dash.domain_breakdown": "Alan dağılımı",
    "dash.domain_subtitle": "PMBOK 8 — son deneme",
    "dash.no_attempts": "Henüz deneme yok.",
    "dash.no_attempts_link": "Hızlı bir pratik sınav yap",
    "dash.no_attempts_suffix": "ve panelin canlansın.",
    "dash.ai_insight": "AI ÖNGÖRÜSÜ",
    "dash.weakest": "En zayıf",
    "dash.weakest_suffix": "Bir sonraki çalışmanı buraya odakla.",
    "dash.coach": "AI Koçu",
    "dash.coach_title": "Sıradaki adımı sor",
    "dash.coach_sub": "Son denemenin ışığında, sana özel ve odaklı bir adım al.",
    "dash.coach_btn": "Koça sor",
    "dash.coach_thinking": "Düşünüyor…",
    "dash.focus_generating": "Bugünün odağı hazırlanıyor…",
    "dash.focus_refresh": "Yeniden üret",
    "dash.focus_minutes": "dk",
    "dash.focus_chat": "Koça bir soru sor",
    "dash.focus_cooldown": "Lütfen kısa bir süre bekleyip tekrar dene.",
    "dash.coach_unavailable": "Koç şu anda kullanılamıyor",
    "dash.progress_overline": "Zaman içindeki ilerleme",
    "dash.progress_title": "Skor geçmişi",
    "dash.no_history": "Henüz geçmiş yok — sınav bitir, ilerlemeni gör.",
    "dash.tasks_open": "{n} açık",
    "dash.view_all": "Tümünü gör",
    "dash.no_tasks": "Henüz görev yok — bir sınav bitir, biz ekleriz.",
    "dash.activity": "AKTİVİTE",
    "dash.recent_updates": "Son güncellemeler",
    "dash.no_notifications": "Henüz bildirim yok.",
    "dash.inactivity": "{days} gündür çalışmıyorsun.",
    "dash.inactivity_suffix": "15 dakikalık bir oturum serini canlı tutar.",
    "dash.load_failed": "Panel yüklenemedi",

    // Practice
    "practice.overline": "PRATİK",
    "practice.title": "Tekrarını yap.",
    "practice.subtitle": "Bir alan, zorluk ve uzunluk seç. Her cevap açıklanır ve takip edilir.",
    "practice.domain": "Alan",
    "practice.difficulty": "Zorluk",
    "practice.questions": "Soru",
    "practice.start": "Pratiğe başla",
    "practice.preparing": "Hazırlanıyor…",
    "practice.could_not_start": "Sınav başlatılamadı",
    "diff.easy": "Kolay", "diff.medium": "Orta", "diff.hard": "Zor",
    "domain.People": "İnsanlar", "domain.Process": "Süreç", "domain.Business Environment": "İş Ortamı",

    // Quiz Runner
    "quiz.mock_label": "DENEME SINAVI",
    "quiz.practice_label": "PRATİK",
    "quiz.q_of": "Soru {n} / {total}",
    "quiz.answered": "Cevaplanan:",
    "quiz.submitting": "Gönderiliyor…",
    "quiz.finish_analyze": "Bitir ve analiz et",
    "quiz.failed_submit": "Deneme gönderilemedi",
    "quiz.translating": "Çevriliyor…",

    // Mock Exam
    "mock.title": "180 soru · 230 dakika",
    "mock.subtitle": "Gerçek sınav planı — 76 İnsanlar, 90 Süreç, 14 İş Ortamı. Sayaç 03:50:00'dan geri sayar. Erken bitirebilirsin. AI analizi gönderdiğinde otomatik çalışır.",
    "mock.warning": "Başladıktan sonra sayaç durdurulamaz.",
    "mock.start": "Deneme sınavını başlat",
    "mock.scoring": "Puanlama ve AI analizi yapılıyor…",
    "mock.could_not_start": "Sınav başlatılamadı",
    "mock.submit_failed": "Gönderim başarısız",
    "mock.submit": "Gönder",
    "mock.finish_exam": "Sınavı bitir",

    // Results
    "results.overline_results": "SONUÇLAR",
    "results.title": "Denemen puanlandı.",
    "results.score": "Skor",
    "results.domain_breakdown": "Alan Dağılımı",
    "results.ai_overline": "AI KOÇU",
    "results.diagnosis": "Tanı",
    "results.weak": "Zayıf",
    "results.strong": "Güçlü",
    "results.improvement": "İyileştirme planı",
    "results.next_steps": "Önerilen sonraki adımlar",
    "results.update_plan": "Çalışma planımı güncelle",
    "results.practice_weak": "Zayıf alanı çalış",
    "results.review_count": "İnceleme · {n} soru",
    "results.explanation": "AÇIKLAMA",
    "results.could_not_load": "Deneme yüklenemedi",

    // Tasks
    "tasks.overline": "GÖREVLER",
    "tasks.title": "Çalışma sıran",
    "tasks.add": "Yeni görev",
    "tasks.create_failed": "Görev oluşturulamadı",
    "tasks.added": "Görev eklendi",
    "tasks.all_caught_up": "Hepsi hallolmuş.",
    "tasks.no_completed": "Henüz tamamlanmış görev yok.",
    "tasks.due": "son",
    "tasks.overdue": "gecikmiş",

    // Study Plan
    "plan.overline": "HAFTALIK PLAN",
    "plan.title": "AI ile kurulan haftan",
    "plan.subtitle": "Alan skorların değiştikçe planlar otomatik uyarlanır.",
    "plan.regenerate": "Yeniden oluştur",
    "plan.generating": "Oluşturuluyor…",
    "plan.refreshed": "Çalışma planı yenilendi",
    "plan.no_plan": "İlk haftalık planını oluştur",
    "plan.no_plan_sub": "Son denemenden plan kuracağız — yoksa varsayılanları kullanırız.",
    "plan.generate": "Plan oluştur",
    "plan.rationale": "AI GEREKÇESİ",
    "plan.target": "Hedef:",
    "plan.target_suffix": "soru",
    "plan.could_not_refresh": "Plan yenilenemedi",

    // Progress
    "progress.overline": "İLERLEME",
    "progress.title": "Yörüngen",
    "progress.no_attempts": "Henüz deneme yok",
    "progress.no_attempts_sub": "Pratik sınav veya deneme sınavı yaparak yörüngeni başlat.",
    "progress.score_readiness": "Skor ve Hazırlık zaman içinde",
    "progress.domain_avg": "Alan ortalamaları (son 5)",
    "progress.history": "Deneme geçmişi",
    "progress.col.date": "Tarih", "progress.col.mode": "Mod", "progress.col.score": "Skor",
    "progress.col.readiness": "Hazırlık", "progress.col.questions": "Soru",
    "progress.review_link": "İncele →",

    // Profile
    "profile.overline": "PROFİL",
    "profile.title": "Hesabın",
    "profile.account": "Hesap",
    "profile.signin_method": "Giriş yöntemi",
    "profile.plan": "Plan",
    "profile.recommended": "ÖNERİLEN",
    "profile.current": "Mevcut plan",
    "profile.upgrading": "Yükseltiliyor…",
    "profile.upgrade_mock": "Yükselt (örnek)",
    "profile.toast_mock": "{tier} planına geçiş simüle edildi (MVP'de ödeme yok)",
    "auto.strengthen": "{domain} alanını güçlendir",
    "auto.strengthen_desc": "Bu alanda 15 hedefli soru çöz ve her açıklamayı incele.",

    // Streak & daily goal
    "streak.title": "Günlük seri",
    "streak.current": "Mevcut",
    "streak.longest": "En uzun",
    "streak.days": "gün",
    "streak.goal": "Günlük hedef",
    "streak.today": "Bugün",
    "streak.goal_set": "Günlük hedef güncellendi",
    "streak.goal_failed": "Hedef güncellenemedi",
    "streak.goal_hit": "Hedefe ulaştın — alev!",
    "streak.start_today": "Bugünkü tekrarına başla",
    "streak.keep_going": "Hedef için {remaining} soru daha",

    // Review (spaced repetition)
    "nav.review": "Tekrar",
    "review.overline": "ARALIKLI TEKRAR",
    "review.title": "Tekrar kuyruğun",
    "review.subtitle": "Yanlış yaptığın sorular doğru zamanda karşına çıksın diye sıraya alınır.",
    "review.due": "Şimdi tekrar et",
    "review.total": "Kuyruktaki toplam",
    "review.start": "Tekrara başla",
    "review.empty": "Sırada bir şey yok — pratiğe devam et, yanlış yaptıkların buraya düşecek.",
    "review.no_due": "Hepsi hallolmuş!",
    "review.starting": "Tekrar yükleniyor…",
    "review.could_not_start": "Tekrar başlatılamadı",
    "review.dashboard_label": "Tekrar kuyruğu",
    "review.dashboard_due": "{n} tekrar bekliyor",

    // Adaptive
    "practice.adaptive": "Uyarlanabilir zorluk",
    "practice.adaptive_hint": "Yapay zeka, son doğruluk oranına göre zorluğu otomatik ayarlar.",
    "practice.mode_review": "Tekrar modu",

    // Analytics
    "analytics.section": "Analitik",
    "analytics.radar_overline": "ALAN KAPSAMI",
    "analytics.radar_title": "Performans haritası",
    "analytics.current": "Mevcut",
    "analytics.best": "En iyi",
    "analytics.heatmap_overline": "AKTİVİTE",
    "analytics.heatmap_title": "Son 12 hafta",
    "analytics.total_solved": "Toplam çözülen",
    "analytics.active_days": "aktif gün",
    "analytics.less": "Az",
    "analytics.more": "Çok",
    "analytics.donut_overline": "ZORLUK DAĞILIMI",
    "analytics.donut_title": "Çözülen sorular",
    "analytics.acc_diff_overline": "İSABET",
    "analytics.acc_diff_title": "Zorluğa göre doğruluk",
    "analytics.spark_overline": "EĞİLİM",
    "analytics.spark_title": "Alan bazlı eğilim",
    "analytics.totals_overline": "ÖZET",
    "analytics.total_minutes": "Çalışma dakikası",
    "analytics.overall_accuracy": "Genel doğruluk",

    // Nav (public)
    "nav.home": "Ana Sayfa",
    "nav.about": "Hakkımızda",
    "nav.contact": "İletişim",
    "nav.privacy": "Gizlilik",
    "nav.kvkk": "KVKK",
    "nav.terms": "Üyelik Sözleşmesi",
    "nav.distance_sales": "Mesafeli Satış Sözleşmesi",
    "nav.refund": "İptal ve İade",
    "nav.cookies": "Çerez Politikası",
    "nav.faq": "SSS",
    "nav.admin": "Yönetim",
    "nav.affiliate": "Ortaklık",

    // Footer
    "footer.tagline": "Her cevabını izleyen, haftanı yeniden planlayan yapay zekâ destekli PMP koçluğu.",
    "footer.product": "Ürün",
    "footer.company": "Şirket",
    "footer.legal": "Yasal",
    "footer.rights": "Tüm hakları saklıdır.",

    // Contact page
    "contact.title": "Bize ulaşın",
    "contact.subtitle": "Sorular, iş birliği veya geri bildirim için yazın — 24 saat içinde yanıtlıyoruz.",
    "contact.subject": "Konu",
    "contact.message": "Mesaj",
    "contact.send": "Mesajı gönder",
    "contact.sending": "Gönderiliyor…",
    "contact.sent": "Mesajınız iletildi — kısa sürede dönüş yapacağız.",
    "contact.phone": "Telefon",
    "contact.address": "Adres",

    // FAQ page
    "faq.subtitle": "PMP yolculuğuna başlamadan önce bilmeniz gereken her şey.",

    // Admin panel
    "admin.title": "Site Yönetimi",
    "admin.subtitle": "Genel sayfaları, iletişim bilgilerini, SSS, sosyal medya bağlantılarını ve gelen mesajları düzenleyin.",
    "admin.title_tr": "Başlık (TR)",
    "admin.title_en": "Başlık (EN)",
    "admin.body_tr": "İçerik (TR)",
    "admin.body_en": "İçerik (EN)",
    "admin.question_tr": "Soru (TR)",
    "admin.question_en": "Soru (EN)",
    "admin.answer_tr": "Cevap (TR)",
    "admin.answer_en": "Cevap (EN)",
    "admin.address_tr": "Adres (TR)",
    "admin.address_en": "Adres (EN)",
    "admin.save": "Değişiklikleri kaydet",
    "admin.saving": "Kaydediliyor…",
    "admin.saved": "Kaydedildi",
    "admin.save_failed": "Kaydetme başarısız",
    "admin.deleted": "Silindi",
    "admin.add_question": "Soru ekle",
    "admin.social_hint": "Bir alanı boş bırakırsanız footer'da görünmez.",
    "admin.no_messages": "Henüz mesaj yok.",
    "admin.mark_read": "Okundu işaretle",
    "admin.tab.about": "Hakkımızda",
    "admin.tab.contact_info": "İletişim",
    "admin.tab.privacy": "Gizlilik",
    "admin.tab.kvkk": "KVKK",
    "admin.tab.terms": "Üyelik Söz.",
    "admin.tab.distance_sales": "Mesafeli Satış",
    "admin.tab.refund": "İptal / İade",
    "admin.tab.cookies": "Çerez",
    "admin.tab.faq": "SSS",
    "admin.tab.social_links": "Sosyal",
    "admin.tab.homepage_extra": "Ana Sayfa",
    "admin.tab.messages": "Mesajlar",
    "admin.reset_default": "Varsayılana sıfırla",
    "admin.reset_confirm": "Bu sayfayı paket gelen varsayılan şablona sıfırlamak istediğinize emin misiniz? Yaptığınız düzenlemeler kaybolacak.",
    "admin.reset_success": "Varsayılan şablona sıfırlandı.",
    "admin.delete": "Sil",
    // Admin Overview
    "overview.total_users": "Toplam kullanıcı",
    "overview.new": "Yeni",
    "overview.paying": "Ödeme yapan",
    "overview.conversion": "dönüşüm",
    "overview.mrr": "MRR",
    "overview.monthly_recurring": "Aylık tekrarlayan gelir",
    "overview.revenue_30d": "Gelir (30g)",
    "overview.total": "Toplam",
    "overview.affiliates": "Affiliate ortağı",
    "overview.active": "aktif",
    "overview.active_coupons": "Aktif kuponlar",
    "overview.redemptions": "kullanım",
    "overview.unread_msg": "Okunmamış mesaj",
    "overview.contact_forms": "İletişim formları",
    "overview.pro_active": "Aktif Pro",
    "overview.recent_payments": "Son ödemeler",
    "overview.no_payments_yet": "Henüz ödeme yok.",
    "overview.recent_signups": "Son kayıtlar",
    "overview.top_affiliates": "En çok kazanan ortaklar",
    "overview.commissions": "komisyon",
    // Coupons
    "admin.tab.overview": "Genel Bakış",
    "admin.tab.plans": "Fiyatlar",
    "admin.tab.coupons": "Kuponlar",
    "admin.coupon_new": "Yeni kupon oluştur",
    "admin.coupon_create": "Kupon oluştur",
    "admin.coupon_created": "Kupon oluşturuldu.",
    "admin.coupon_list": "Tüm kuponlar",
    "admin.coupon_none": "Henüz kupon yok — yukarıdan ilk kampanya kodunuzu oluşturun.",
    "admin.coupon_code": "Kod",
    "admin.coupon_discount": "İndirim",
    "admin.coupon_used": "Kullanım",
    "admin.coupon_status": "Durum",
    "admin.coupon_active": "Aktif",
    "admin.coupon_inactive": "Pasif",
    "admin.coupon_type_percent": "Yüzde (%)",
    "admin.coupon_type_fixed": "Sabit (₺)",
    "admin.coupon_per_user_limit": "Kullanıcı başı limit (varsayılan 1)",
    "admin.coupon_total_limit": "Toplam kullanım limiti (boş = sınırsız)",
    "admin.coupon_plans": "Geçerli planlar",
    "admin.coupon_empty_means_all": "boş = tüm planlar",
    "admin.coupon_note": "Dahili not (örn: kampanya adı)",
    "admin.coupon_delete_confirm": "{code} kuponunu silmek istediğinize emin misiniz? Bu işlem geri alınamaz.",
    "admin.pretranslate_title": "Türkçe Ön Çeviri",
    "admin.pretranslate_running": "Sorular Türkçe'ye çevriliyor:",
    "admin.pretranslate_complete": "Tüm sorular Türkçe'ye çevrildi ✓",
    "admin.pretranslate_idle": "Tüm sorular zaten çevrilmiş durumda.",
    "admin.pretranslate_run": "Şimdi çalıştır",
    "admin.pretranslate_started": "Ön çeviri arka planda başlatıldı.",

    // Cookie banner
    "cookie.title": "Çerezler kullanıyoruz",
    "cookie.body": "Sitenin çalışması için zorunlu çerezler ve geliştirmek için isteğe bağlı analitik çerezler kullanıyoruz. Tercihinizi istediğiniz zaman değiştirebilirsiniz.",
    "cookie.learn_more": "Daha fazla bilgi",
    "cookie.accept": "Tümünü kabul et",
    "cookie.essential_only": "Sadece zorunlular",

    // Consent (register)
    "consent.kvkk": "{privacy} ve {kvkk} metinlerini okudum, kabul ediyorum.",
    "consent.kvkk_privacy": "Gizlilik Bildirimi",
    "consent.kvkk_text": "KVKK Aydınlatma Metni",
    "consent.kvkk_tail": "metinlerini okudum, kabul ediyorum.",
    "consent.terms": "Üyelik Sözleşmesi",
    "consent.distance_sales": "Mesafeli Satış Sözleşmesi",
    "consent.marketing": "Ürün güncellemeleri ve çalışma ipuçlarını e-posta ile almak istiyorum (isteğe bağlı).",
    "consent.required": "Devam etmek için Gizlilik Bildirimi ve KVKK Aydınlatma Metni'ni kabul etmelisiniz.",

    // Exam countdown
    "countdown.title": "PMP sınav tarihi",
    "countdown.days_left": "gün kaldı",
    "countdown.today": "Bugün sınav günü!",
    "countdown.past_exam": "Sınav tarihi geçti — güncelle veya temizle",
    "countdown.urgent_message": "Bir haftadan az kaldı — mock sınavlara yoğunlaş, zayıf domainleri tekrar et.",
    "countdown.save": "Tarihi kaydet",
    "countdown.edit": "Düzenle",
    "countdown.cancel": "Vazgeç",
    "countdown.clear": "Temizle",

    // SEO
    "seo.default.title": "Yapay Zeka Destekli PMP Sınav Hazırlığı",
    "seo.default.description": "PMCoach AI, yapay zeka destekli PMP koçluk platformudur. Adaptif pratik, tam 180 soruluk mock sınavlar ve zayıf domainlerinize göre kendini güncelleyen kişisel çalışma planı.",
    "seo.default.keywords": "PMP hazırlık, PMP soruları, PMBOK 8, proje yönetimi sertifikası, PMP simülatörü, yapay zeka koç",
    "seo.landing.title": "Yapay Zeka Koçlu PMP Sınav Hazırlığı",
    "seo.landing.description": "Her cevabınızı izleyen ve haftalık planınızı yeniden kuran AI koçla PMP sınavını daha hızlı geçin. 1700+ çift dilli soru, tam mock sınavlar, aralıklı tekrar.",
    "seo.landing.keywords": "PMP sınavı, PMP hazırlık, PMP deneme sınavı, proje yönetimi, PMBOK 8",
    "seo.login.title": "Giriş yap",
    "seo.login.description": "PMCoach AI'a giriş yapın ve AI koçluk yolculuğunuza devam edin.",
    "seo.register.title": "Ücretsiz hesap oluşturun",
    "seo.register.description": "Günde 10 soru ile ücretsiz başlayın. İstediğiniz zaman sınırsız pratik ve AI koçluk için yükseltin.",
    "seo.dashboard.title": "PMP Panelim",
    "seo.dashboard.description": "Domain radarı, doğruluk ısı haritası, hazırlık skoru ve kişisel çalışma planı — hepsi tek yerde.",
    "seo.about.title": "PMCoach AI Hakkında",
    "seo.about.description": "Yapay zeka destekli bir PMP koçunu neden inşa ettik ve klasik soru bankalarından nasıl farklı?",
    "seo.privacy.title": "Gizlilik Bildirimi",
    "seo.privacy.description": "PMCoach AI kişisel verilerinizi nasıl topluyor, işliyor ve koruyor.",
    "seo.kvkk.title": "KVKK Aydınlatma Metni",
    "seo.kvkk.description": "PMCoach AI KVKK aydınlatma metni ve haklarınız.",
    "seo.faq.title": "Sıkça Sorulan Sorular",
    "seo.faq.description": "PMCoach AI, PMP sınavı ve AI koçluğumuz hakkında en sık sorulan sorulara cevaplar.",
    "seo.blog.title": "PMP ve PMBOK 8 Blog",
    "seo.blog.description": "PMP sınavına daha hızlı hazırlanmanız için rehberler, çalışma planları ve PMBOK 8 detayları.",
    "seo.blog.keywords": "PMP blog, PMBOK 8 rehberi, PMP hazırlık ipuçları, proje yönetimi blog",
    "seo.blog_post.title": "PMCoach AI Blog",
    "seo.blog_post.description": "PMCoach AI ekibinden PMP ve PMBOK 8 konularında ayrıntılı içerikler.",
    "blog.overline": "BLOG",
    "blog.title": "PMP ve PMBOK 8 rehberi",
    "blog.subtitle": "PMCoach AI ekibinden pratik rehberler ve çalışma planları.",
    "blog.empty": "Henüz yazı yok — yakında görüşürüz.",
    "blog.read_more": "Devamını oku",
    "blog.back_to_list": "Blog'a dön",
    "blog.min_read": "dk okuma",
    "blog.notfound_title": "Yazı bulunamadı",
    "blog.notfound_body": "Bu yazı taşınmış veya kaldırılmış olabilir.",
    "blog.cta_title": "Okuduklarını pratiğe döktüğün an!",
    "blog.cta_body": "PMCoach AI'a kaydol, bu fikirleri gerçek bir çalışma planına dönüştür.",
    "blog.cta_button": "Hemen başla",
    "seo.contact.title": "Bize ulaşın",
    "seo.contact.description": "Sorular, iş birliği veya geri bildirim için bize yazın.",
    "seo.profile.title": "Profil & Abonelik",
    "seo.profile.description": "PMCoach AI aboneliğinizi, ödeme yönteminizi ve hesap bilgilerinizi yönetin.",

    // Dashboard PDF
    "dash.pdf_download": "PDF rapor indir",
    "dash.pdf_downloading": "Hazırlanıyor…",

    // Affiliate
    "affiliate.overline": "ORTAKLIK PROGRAMI",
    "affiliate.title": "Satış Ortaklığı Programı",
    "affiliate.subtitle": "Yönlendirdiğiniz her PMCoach AI aboneliğinden komisyon kazanın. Hibrit model: yüksek ilk ödeme komisyonu + tekrarlayan gelir.",
    "affiliate.apply_form_title": "Ortak ol",
    "affiliate.apply_intro": "Kendinizi ve PMCoach AI'ı nasıl tanıtacağınızı kısaca anlatın. Başvuruları 2 iş günü içinde inceliyoruz.",
    "affiliate.benefit_1": "Her ilk ödemeden %{rate} komisyon",
    "affiliate.benefit_2": "Her yenilemeden %{rate} tekrarlayan komisyon",
    "affiliate.benefit_3": "Özel takip linki + canlı dashboard",
    "affiliate.name_placeholder": "İsminiz veya şirket adınız",
    "affiliate.contact_placeholder": "Ödeme için telefon veya IBAN (opsiyonel, sonra ekleyebilirsiniz)",
    "affiliate.audience_placeholder": "Kitleniz (örn. PMI Türkiye LinkedIn grubu)",
    "affiliate.notes_placeholder": "Nasıl tanıtacağınızı anlatın — kanallar, içerik vs.",
    "affiliate.submit_button": "Başvuruyu gönder",
    "affiliate.submitting": "Gönderiliyor…",
    "affiliate.application_submitted": "Başvurunuz alındı! Kısa sürede dönüş yapacağız.",
    "affiliate.application_failed": "Gönderim başarısız. Lütfen tekrar deneyin.",
    "affiliate.pending_overline": "İNCELEMEDE",
    "affiliate.pending_title": "Başvurunuz inceleniyor",
    "affiliate.pending_body": "Ortaklık başvurularını 2 iş günü içinde inceliyoruz. Hesabınız aktif olur olmaz ve takip linkiniz hazırlanır hazırlanmaz e-posta ile bilgi vereceğiz.",
    "affiliate.total_referrals": "Toplam yönlendirme",
    "affiliate.paying_referrals": "Ödeme yapan müşteri",
    "affiliate.total_earned": "Toplam kazanç",
    "affiliate.pending": "ödeme bekleyen",
    "affiliate.your_link": "Takip linkiniz",
    "affiliate.copy": "Kopyala",
    "affiliate.link_copied": "Link panoya kopyalandı.",
    "affiliate.code_label": "Kod",
    "affiliate.first_rate": "İlk ödeme oranı",
    "affiliate.recurring_rate": "Yenileme oranı",
    "affiliate.recent_commissions": "Son komisyonlar",
    "affiliate.no_commissions": "Henüz komisyon yok — kazanmaya başlamak için linkinizi paylaşın.",
    "affiliate.col_date": "Tarih",
    "affiliate.col_referred": "Yönlendirilen kullanıcı",
    "affiliate.col_plan": "Plan",
    "affiliate.col_gross": "Brüt",
    "affiliate.col_rate": "Oran",
    "affiliate.col_commission": "Komisyon",
    "affiliate.col_status": "Durum",
    "affiliate.status_paid": "Ödendi",
    "affiliate.status_pending": "Bekliyor",
    "common.failed": "Başarısız",

    // Billing / iyzico
    "billing.period_month": "/ ay",
    "billing.period_year": "/ yıl",
    "billing.period_forever": "süresiz",
    "billing.period_trial": "30 gün deneme",
    "billing.period_3month": "/ 3 ay",
    "billing.period_6month": "/ 6 ay",
    "billing.plan_free_name": "Ücretsiz Deneme",
    "billing.plan_monthly_name": "1 Aylık",
    "billing.plan_quarterly_name": "3 Aylık",
    "billing.plan_semi_name": "6 Aylık",
    "billing.plan_pro_name": "Pro",
    "billing.plan_master_name": "Premium",
    "billing.feat_full_1": "1.700+ pratik soru (TR + EN tam çeviri)",
    "billing.feat_full_2": "Sınırsız tam mock sınav (180 soru)",
    "billing.feat_full_3": "AI Koç — her denemeden sonra kişisel yorum",
    "billing.feat_full_4": "Aralıklı tekrar + adaptif zorluk",
    "billing.feat_full_5": "6 sayfalık premium PDF hazırlık raporu",
    "billing.feat_full_6": "Otomatik haftalık çalışma planı",
    "billing.kdv_included": "KDV %20 dahildir",
    "billing.upgrade_paytr": "PayTR ile yükselt",
    "billing.always_free": "Her zaman ücretsiz",
    "billing.starting": "Başlatılıyor…",
    "billing.expires_on": "Yenileme",
    "billing.saved_card": "Kayıtlı kart",
    "billing.cancel_renew": "Otomatik yenilemeyi kapat",
    "billing.cancel_success": "Otomatik yenileme kapatıldı. Erişiminiz yenileme tarihine kadar sürer.",
    "billing.cancel_failed": "Otomatik yenileme kapatılamadı.",
    "billing.payment_success": "Ödeme alındı — aramıza hoş geldiniz!",
    "billing.payment_failed": "Ödeme başarısız veya iptal edildi.",
    "billing.init_failed": "Ödeme başlatılamadı. Lütfen tekrar deneyin.",
    "billing.paytr_safe": "PayTR ile güvenli ödeme · 3D Secure",
    "billing.secure_payment": "Güvenli Ödeme",
    "billing.complete_payment": "Ödemenizi tamamlayın",
    "billing.not_configured_warning": "Ödemeler henüz yapılandırılmadı. Yöneticinin iyzico API anahtarlarını eklemesi gerekiyor.",
    "billing.feat_free_1": "30 gün ücretsiz deneme, tüm özellikler açık",
    "billing.feat_free_2": "Tam mock sınavlar + AI Koç dahil",
    "billing.feat_free_3": "Kredi kartı gerektirmez",
    "billing.feat_pro_1": "Sınırsız pratik sorusu",
    "billing.feat_pro_2": "Tam 180 soruluk mock sınavlar",
    "billing.feat_pro_3": "Her denemede AI Koç (GPT-5.2)",
    "billing.feat_pro_4": "Adaptif zorluk motoru",
    "billing.feat_pro_5": "Türkçe/İngilizce çift dilli sorular",
    "billing.feat_master_1": "Pro'daki her şey",
    "billing.feat_master_2": "Aylığa göre 2 ay ücretsiz",
    "billing.feat_master_3": "Kişisel çalışma planı",
    "billing.feat_master_4": "PDF hazırlık raporu",
    "billing.feat_master_5": "Öncelikli destek",
    "billing.feat_master_6": "Yeni özelliklere erken erişim",
    "billing.have_coupon": "Kupon kodunuz mu var?",
    "billing.apply_coupon": "Uygula",
    "billing.coupon_valid": "Kupon geçerli — ödeme sırasında {amount}₺ indirim uygulanacak.",
    "billing.coupon_invalid": "Kupon geçersiz veya süresi dolmuş.",
    "billing.discount_applied": "indirim uygulanacak",
  },
};

export const DOMAIN_LABEL = {
  en: { "People": "People", "Process": "Process", "Business Environment": "Business Environment" },
  tr: { "People": "İnsanlar", "Process": "Süreç", "Business Environment": "İş Ortamı" },
};

export const DIFF_LABEL = {
  en: { easy: "Easy", medium: "Medium", hard: "Hard" },
  tr: { easy: "Kolay", medium: "Orta", hard: "Zor" },
};

export function format(str, vars) {
  if (!vars) return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : `{${k}}`));
}
